/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Orgs_Clear_FilterInputs */



/**
* | output |
* | --- |
* | "Show all" |
*
* @param {Partner_Orgs_Clear_FilterInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_orgs_clear_filter = /** @type {((inputs?: Partner_Orgs_Clear_FilterInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Orgs_Clear_FilterInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Alle anzeigen")
	return /** @type {LocalizedString} */ ("Show all")
});